import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import ContentSave from 'material-ui/svg-icons/content/save';
import CircularProgress from 'material-ui/CircularProgress';

/**
 * A Save button component that is disabled until a condition is met
 */
export class SaveButtonWithCondition extends Component {
    handleClick = e => {
        if (this.props.saving) {
            // prevent double submission
            e.preventDefault();
        } else {
            // always submit form explicitly regardless of button type
            const {handleSubmitWithRedirect, redirect} = this.props;
            if (e) {
                e.preventDefault();
            }
            handleSubmitWithRedirect(redirect)();
        }
    };

    render() {
        const {
            disabled,
            label,
            saving,
            raised = true,
            submitOnEnter,
            redirect,
        } = this.props;
        const type = submitOnEnter ? 'submit' : 'button';
        const ButtonComponent = raised ? RaisedButton : FlatButton;
        return (
            <ButtonComponent
                type={type}
                label={label}
                disabled={disabled}
                icon={
                    saving && saving.redirect === redirect ? (
                        <CircularProgress size={25} thickness={2}/>
                    ) : (
                        <ContentSave/>
                    )
                }
                onClick={this.handleClick}
                primary={!saving}
                style={{
                    margin: '10px 24px',
                    position: 'relative',
                }}
            />
        );
    }
}

SaveButtonWithCondition.propTypes = {
    disabled: PropTypes.bool,
    field: PropTypes.string.isRequired,
    fieldComparison: PropTypes.string.isRequired,
    fieldCondition: PropTypes.any.isRequired,
    label: PropTypes.string,
    raised: PropTypes.bool,
    saving: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    submitOnEnter: PropTypes.bool,
    handleSubmitWithRedirect: PropTypes.func,
    redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

SaveButtonWithCondition.defaultProps = {
    disabled: true,
    fieldComparison: 'EQUALS',
    fieldCondition: true,
    handleSubmitWithRedirect: () => () => {
    },
};

/**
 * Compare the provided field's status or value to determine Save button's disabled status
 *
 * @param values
 * @param props
 * @return {*}
 */
const checkForm = (values, props) => {
    const comparison = props.fieldComparison;
    const condition = props.fieldCondition;
    const field = props.field;
    switch (comparison) {
        case 'exists':
            return (condition === 'true')
                ? (values[field] && values[field] !== '')
                : (!values[field]);
        case 'equals':
            return (values[field] && values[field] === condition);
        case 'gt':
            return (values[field] && values[field] > condition);
        case 'gte':
            return (values[field] && values[field] >= condition);
        case 'lt':
            return (values[field] && values[field] < condition);
        case 'lte':
            return (values[field] && values[field] <= condition);
        default:
            return true
    }
};

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        return {
            disabled: !checkForm(form.values, ownProps),
            saving: state.admin.saving,
        }
    }
    return {}
};

export default connect(mapStateToProps)(SaveButtonWithCondition);



// WEBPACK FOOTER //
// ./src/Fuse/buttons/SaveButtonWithCondition.js